import type { ImgHTMLAttributes } from 'react';

type CremeLogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>;

function CremeLogo(props: CremeLogoProps) {
  return (
    <img
      src="/images/cremeberry-logo.jpg"
      alt="Crème Berry — San Francisco patisserie"
      {...props}
    />
  );
}

export default CremeLogo;
